import { render, staticRenderFns } from "./ConnectionView.vue?vue&type=template&id=550b12f4"
import script from "./connectionView.ts?vue&type=script&lang=js&external"
export * from "./connectionView.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports